import React, { Component } from 'react';
import {

  CCard,
  CCardBody,
  CCardHeader,

} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { withRouter } from 'react-router-dom'
import { APIS } from '../../config'
import { did, utils } from 'mui-metablockchain-sdk';
import {
  METAMUI_ADMINS,
} from "../../config";


class Transactions extends Component {

  state = {
    myArr: [],
    transArr: [],
    intervalId: '',

  }

  constructor(props) {
    super(props)
    this.loadData = this.loadData.bind(this)
  }

  componentDidMount() {
    this.loadData()
    let intervalId = setInterval(this.loadData, 10000);
    this.setState({ intervalId: intervalId })

  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId)
    this.setState = (state, callback) => {
      return;
    };
  }


  decodeV2Token(token) {
    let decoded = JSON.parse(atob(token.split(":")[1]));
    return decoded;
  };

  checkIfAdmin() {
    let tokenType = sessionStorage.getItem('tokenType');
    let userDid = sessionStorage.getItem('userDid');
    let userGroups = [];
    if (tokenType === 'v2') {
      let token = sessionStorage.getItem('login');
      let decodedToken = this.decodeV2Token(token);
      userGroups = decodedToken.user_role.split(",");
      userDid = utils.hexToString(decodedToken.user_did);
    }
    let allowedGroups = [
      "council_members",
      "kyc_admins",
      "kyc-admins",
      "ssid-admin",
    ];

    if (METAMUI_ADMINS.includes(userDid)) {
      return true;
    }

    userGroups.forEach((group) => {
      if (allowedGroups.includes(group)) {
        return true;
      }
    });
    return false;
  };

  async loadData() {
    try {
      const token = sessionStorage.getItem('login')
      let res1;
      if (token === null) {
        res1 = await fetch(APIS + 'balances/transfer');
      } else {
        res1 = await fetch(APIS + 'balances/transfer', {
          headers: new Headers({
            'Authorization': token
          })
        });
      }
      // const res1 = await fetch(APIS+'balances/transfer');

      let balanceTrans = await res1.json();
      let logged_in_did = sessionStorage.getItem('userDid');
      let sanitisedDid;
      if (logged_in_did) {
        sanitisedDid =  did.sanitiseDid(logged_in_did);
      }

      let transactions = balanceTrans.data.map((t) => {
        let transaction = {
          id: t.id,
          sender: t.attributes.sender.attributes.address,
          receiver: t.attributes.destination.attributes.address,
          amount: t.attributes.value / 1e6,
        };
        if (this.checkIfAdmin() || (sanitisedDid === '0x' + t.attributes.sender.attributes.id || sanitisedDid === '0x' + t.attributes.destination.attributes.id)) {
          return {
            ...transaction,
            sender: utils.hexToString(t.attributes.sender.attributes.id),
            receiver: utils.hexToString(t.attributes.destination.attributes.id),
          }
        }
        return transaction;
      })

      this.setState({ transArr: transactions })

    } catch (e) {
      console.log(e);
    }
  }



  render() {
    const { history } = this.props;
    return (
      <div>
        <CCard>
          <CCardHeader>
            MetaMUI Transactions
          </CCardHeader>
          <CCardBody>


            <table className="table table-hover table-outline mb-0 table-responsive d-sm-table">
              <thead className="thead-light">
                <tr>
                  <th className="text-center"><CIcon name="cil-people" /></th>
                  <th>Sender</th>
                  <th className="text-center">Receiver</th>
                  {/* <th className="text-center">Amount</th> */}
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>

                {this.state.transArr.map((e, index) =>

                  <tr onClick={() => history.push('/tnx-details/' + e.id + `/${this.props?.selectedToken ? this.props.selectedToken.name : 'MetaMUI'}`)} key={index}>
                    <td className="text-center">
                      <div className="c-avatar">
                        <strong>{index + 1} </strong>
                      </div>
                    </td>
                    <td>
                      <div><strong>{e.sender}</strong></div>
                      <div className="small text-muted">
                        <span>Block</span> | Added <strong>: {e.id}</strong>
                      </div>
                    </td>
                    <td className="text-center">
                      {/* <CIcon height={25} name="cif-us" title="us" id="us" /> */}
                      <div><strong>{e.receiver}</strong></div>
                    </td>

                    {/* <td className="text-center">
                            <CIcon height={25} name="cib-cc-mastercard" />
                          </td> */}
                    <td>
                      <div className="small text-muted">Last block created</div>
                      <strong>{e.amount} MetaMUI </strong>
                    </td>
                  </tr>


                )}


              </tbody>
            </table>

          </CCardBody>
        </CCard>



      </div>
    );
  }
}

export default withRouter(Transactions);